// extracted by mini-css-extract-plugin
export default {"truncatedContentContainer":"styles_truncatedContentContainer__iqxbB","content":"styles_content__yCM+U","expandBtn":"styles_expandBtn__eEygd"};